/******************************************************************
 * Archivo : client/src/components/Header/index.js
 * Proyecto: CB30
 *
 * Header único para todos los usuarios autenticados.
 *
 * La navegación se determina dinámicamente a partir de los
 * permisos del rol del usuario.
 ******************************************************************/

import React from "react";
import { graphql } from "react-apollo";

// Query
import query from "../../queries/fetchUser";

// Component
import UserHeader from "./UserHeader";

const Header = props => {
  const renderContent = () => {
    if (props.data.loading) {
      return <div />;
    }

    if (props.data.user) {
      return <UserHeader />;
    }

    // ------------------------------------------------------------
    // Authentication redirect
    //
    // Production:
    //   Express sirve React y /login.
    //
    // Development:
    //   React corre en localhost:3000 mientras Express
    //   maneja la autenticación en localhost:5000.
    // ------------------------------------------------------------
    if (
      typeof window !== "undefined" &&
      window.location.pathname !== "/login"
    ) {
      if (window.location.hostname === "localhost") {
        window.location.replace("http://localhost:5000/login");
      } else {
        window.location.replace("/login");
      }
    }

    return null;
  };

  return (
    <React.Fragment>
      {renderContent()}
    </React.Fragment>
  );
};

export default graphql(query, {
  options: {
    fetchPolicy: "network-only"
  }
})(Header);


// WEBPACK FOOTER //
// ./src/components/Header/index.js